import ConfirmDialog, {
  ConfirmDialogProps,
} from "pages/CaseDetail/components/ConfirmDialog";

type ReopenApplicationDialogProps = Omit<
  ConfirmDialogProps,
  "title" | "confirmLabel" | "children"
>;

const ReopenApplicationDialog: React.FC<ReopenApplicationDialogProps> = (
  props,
) => (
  <ConfirmDialog
    {...props}
    title="Re-request Application"
    confirmLabel="Re-request Application"
  >
    <p className="mb-2">
      Are you sure you want to Re-request this Application? This will trigger a
      new underwrite of the Application.
    </p>
    <p>
      If you only need to change the debt consolidation form, cancel and edit it
      from the Debt consolidation form row instead.
    </p>
  </ConfirmDialog>
);

export default ReopenApplicationDialog;
